import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button, Card, CardContent } from "@mui/material";
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import TextInput from "../common/TextInput";
import SelectDropdown from "../common/FormSelectDropdown";
import { useLoader } from "../../../pages/LoaderContext";


import FileUpload from "../common/FileUpload";
import "./style.css";
import { makeStyles } from '@mui/styles';
import { errorToast, successToast } from "../../utils/toast";
import { ToastContainer } from 'react-toastify';
import { styled } from '@mui/material/styles';
import AddIconList from "../../../assets/images/plus-icon.svg";
import RemoveIconList from "../../../assets/images/minus-icon.svg";

import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import DateCalendarValue from "../common/Calander/Calander";
import InnoflexSaveModal from "../common/InnoflexSaveModal"

import UnSavedModal from "../common/UnSavedModal"
import ValidationModal from "../common/ValidationModal"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';

// import { getLaunchYears, getLaunchQuarter, getFormat, getLaunchMonth, getLaunchWeek, getCountries, getSclead, getBigbets, getRisks, getProjectStatus, getHCGlobalFilters, uploadImage, createProject } from "../../Services/api/projectService";
import { useProjectApiClient } from "../../Services/api/projectService"

import useLocalStorage from "../../../hooks/useLocalStorage";
import { useAppContext } from '../../../hooks/context/AppContext';
import { projectVersion } from "config/navConfig";
import { stringify } from "querystring";

const useStyles = makeStyles({
  themeButton: {
    backgroundColor: '#2a3fbf !important',
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#2a3fbf !important' },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '80%', // Set width to 80% of the screen
    maxWidth: 'none', // Remove the default maxWidth constraint
    minHeight: '700px'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface Milestone {
  Innoflex_Phase_Options_Key: number;
  Milestone: string;
  ans?: any;
}

interface BrandInfo {
  country_key: string;
  brand_key: string;
  Launch_Year: string;
  launchQuarter: string;
}

interface BrandsInfo {
  selectedBrand: number;
  list: BrandInfo[];
}
interface FormData {
  projectName: string;
  scLead: string;
  buid: string;
  country: string;
  category: string;
  subCategory: string;
  brand: string;
  launchYear: string;
  launchWeek: string;
  projectStatus: string;
  bigBet: string;
  uploadPic: any;
  risk: string;
  comment: string;
  format: string;
  projectExpectation: string;
  issaved: boolean;
  brandsInfo: BrandsInfo;
}


let schema = yup.object().shape({
  projectName: yup.string().required("Project Name is required"),
  scLead: yup.string().required("SC Lead is required"),
  buid: yup.string().required("Buid is required"),
  country: yup.string().required("Country is required"),
  category: yup.string().required("Category is required"),
  subCategory: yup.string().required("Master Brand is required"),
  brand: yup.string().required("Brand is required"),
  launchYear: yup.number().required("Launch Year is required"),
  // launchMonth: yup.string().required("Launch Month is required"),
  launchWeek: yup.string().required("Launch Quarter is required"),
  projectStatus: yup.string().required("Project Status is required"),
  bigBet: yup.string(),
  uploadPic: yup.mixed(),
  risk: yup.string(),
  comment: yup.string(),
  format: yup.string().required("Format is required"),
  projectExpectation: yup.string(),
  brandsInfo: yup.object().shape({
    selectedBrand: yup.number().required(),
    list: yup.array().of(
      yup.object().shape({
        country_key: yup.string().required("Country is required"),
        brand_key: yup.string().required("Brand is required"),
        Launch_Year: yup.number().required("Launch Year is required"),
        Launch_Quarter: yup.string().required("Launch Quarter is required")
      })
    ).min(1, "At least one brand is required")
  })

});

// let schema = yup.object().shape({
//   projectName: yup.string().required("Project Name is required"),
//   scLead: yup.string().required("SC Lead is required"),
//   buid: yup.string().required("Buid is required"),
//   country: yup.string().required("Country is required"),
//   category: yup.string().required("Category is required"),
//   subCategory: yup.string().required("Master Brand is required"),
//   brand: yup.string().required("Brand is required"),
//   launchYear: yup.number().required("Launch Year is required"),
//   launchWeek: yup.string().required("Launch Quarter is required"),
//   projectStatus: yup.string().required("Project Status is required"),
//   bigBet: yup.string(),
//   uploadPic: yup.mixed(),
//   risk: yup.string(),
//   comment: yup.string(),
//   format: yup.string().required("Format is required"),
//   projectExpectation: yup.string(),
//   brandsInfo: yup.object().shape({
//     selectedBrand: yup.number().required(),
//     list: yup.array().of(
//       yup.object().shape({
//         country: yup.string().required("Country is required"),
//         brand: yup.string().required("Brand is required"),
//         launchYear: yup.number().required("Launch Year is required"),
//         launchQuarter: yup.string().required("Launch Quarter is required")
//       })
//     ).min(1, "At least one brand is required")
//   })
// });

const ProjectForm: React.FC = () => {
  const { getLaunchYears, getLaunchQuarter, getFormat, getSclead, getBigbets, getRisks, getProjectStatus, getHCGlobalFilters, uploadImage, createProject, createV2Project, getRequiredField } = useProjectApiClient()
  const { appData, updateAppData, userData } = useAppContext();
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [projectKey, setProjectKey] = useLocalStorage("project_key", null);
  const classes = useStyles();
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    setValue,
    setError,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [scLeads, setScLeads] = useState([])
  const [countries, setCountries] = useState([])
  const [buids, setBuids] = useState([])
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [brands, setBrands] = useState([])
  const [launchYears, setLaunchYears] = useState([])
  // const [launchMonths, setLaunchMonths] = useState([])
  const [launchWeeks, setLaunchWeeks] = useState([])
  const [projectStatus, setProjectStatus] = useState([])
  const [bigBets, setBigBets] = useState([])
  const [risks, setRisks] = useState([])
  const [formats, setFormats] = useState([])

  const [open, setOpen] = React.useState<boolean>(false);
  const [scOpnen, setScOpen] = React.useState<boolean>(false);

  const [openCalendar, setOpenCalendar] = useState<string | null>(null);
  //const [format, setFormate] = React.useState('');
  const [innoflexSuccessModal, setInnoflexSuccessModal] = React.useState(false);

  const [innoflexStages] = useState([])
  const [innoflexQuestions, setInnoflexQuestions] = useState([])
  const [activeInnoflexStage, setActiveInnoflexStage] = useState(0)
  const [isDisabled, setIsDisabled] = useState(true);
  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)

  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  // const isIdle = useIdle(5000)
  const isIdle = useIdle(60000 * 10)
  const hasAutoSaved = useRef(false);
  const [imagePreview, setImagePreview] = useState('');
  const [formData, setFormData] = useState({
    projectName: '',
    scLead: '',
    buid: '',
    country: '',
    category: '',
    subCategory: '',
    brand: '',
    launchYear: '',
    launchWeek: '',
    projectStatus: '',
    bigBet: '',
    uploadPic: '',
    risk: '',
    comment: '',
    format: '',
    projectExpectation: '',
    issaved: false,
    brandsInfo: {
      selectedBrand: 0,
      list: [
        {
          toSaveMileStone: true,
          "brand_key": "",
          "country_key": "",
          "Launch_Quarter": "",
          "Launch_Year": ""
        }
      ]
    }
  })

  const [initialformData, setInitialformData] = useState(
    {
      projectName: '',
      scLead: '',
      buid: '',
      country: '',
      category: '',
      subCategory: '',
      brand: '',
      launchYear: '',
      launchWeek: '',
      projectStatus: '',
      bigBet: '',
      uploadPic: '',
      risk: '',
      comment: '',
      format: '',
      projectExpectation: '',
      issaved: false,
      brandsInfo: {
        selectedBrand: 0,
        list: [
          {
            toSaveMileStone: true,
            "brand_key": "",
            "country_key": "",
            "Launch_Quarter": "",
            "Launch_Year": ""
          }
        ]
      }
    }
  )


  useEffect(() => {
    fetchscLeads()
    // fetchCountries()
    fetchBigbets()
    fetchRisks()
    fetchProjectStatus()
    fetchYears()
    fetchFormat()
    // fetchWeeks()
    fetchGlobalFilters('all', '0')
    // getInnoflexPhasesData()
    fetchQuarters()
    // getInnoflexQuestionsData()
  }, []);

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);


  useEffect(() => {
    let check = JSON.stringify(formData) === JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }
  }, [formData]);

  React.useEffect(() => {
    if (innoflexStages.length > 0) {
      // getInnoflexQuestionsData();
    }
  }, [innoflexStages]);

  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }

  const onSubmit = async (data: any, type: any, url: string) => {
    let resField = await fetchRequiredField()
    if (resField?.data && resField?.data.filter((val: any) => val.ModuleName !== 'Project Information').length) {
      const groupedErrors = groupByModule(resField?.data.filter((val: any) => val.ModuleName !== 'Project Information'));
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    setLoading(true)
    let id = generateUUID()
    let payload = {
      "project_id": id,
      "project_name": formData.projectName,
      "sclead_key": formData.scLead,
      "subcategory_key": formData.subCategory,
      "category_Key": formData.category,
      "brand_key": formData.brand,
      "country_key": formData.country,
      "project_statuskey": formData.projectStatus,
      "big_bet": formData.bigBet,
      "upload_pic": formData.uploadPic,
      "comment": formData.comment,
      "risk_key": formData.risk,
      "issaved": type,
      "Launch_Quarter": formData.launchWeek,
      "Launch_Year": formData.launchYear,
      "Bu_ID": formData.buid,
      "Project_Exceptions": formData.projectExpectation,
      "Format_Key": formData.format
    }
    let res = await createV2Project(payload)
    setLoading(false)
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: appData.url });
    if (res) {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
      setProjectKey(res?.project?.project_key || "");
      successToast(`Project created successfully`) //Id: ${id}
      resetForm()
      setTimeout(() => {
        navigate(url ? url : `${projectVersion}/project/project-info/${res?.project?.project_id}/${res?.project?.project_key}`)
      }, 2000);
    }
  };

  let saveDraft = async (url: string) => {
    if (!formData.projectName) {
      setError('projectName', {
        type: 'required',
        message: 'Project Name is required'
      });
    }
    else {
      setLoading(true)
      let id = generateUUID()
      let payload = {
        "project_id": id,
        "project_name": formData.projectName,
        "sclead_key": formData.scLead,
        "subcategory_key": formData.subCategory,
        "category_Key": formData.category,
        "project_statuskey": formData.projectStatus,
        "big_bet": formData.bigBet,
        "upload_pic": formData.uploadPic,
        "comment": formData.comment,
        "risk_key": formData.risk,
        "issaved": false,
        "Bu_ID": formData.buid,
        "Project_Exceptions": formData.projectExpectation,
        "Format_Key": formData.format,
        "project_attributes": [
          ...formData.brandsInfo.list
        ]

        // "brand_key": formData.brandsInfo.list[formData.brandsInfo.selectedBrand].brand,
        // "country_key": formData.brandsInfo.list[formData.brandsInfo.selectedBrand].country,
        // "Launch_Quarter": formData.brandsInfo.list[formData.brandsInfo.selectedBrand].launchQuarter,
        // "Launch_Year": formData.brandsInfo.list[formData.brandsInfo.selectedBrand].launchYear,

      }
      let res = await createV2Project(payload)
      setLoading(false)
      if (res) {
        updateAppData({ isFormChanged: false, showUnSavedModal: false });
        setProjectKey(res?.project?.project_key || "");
        successToast(`Project saved as draft successfully`)
        //resetForm()
        setTimeout(() => {
          navigate(url ? url : `${projectVersion}/project/project-info/${res?.project?.project_id}/${res?.project?.project_key}`)
        }, 2000);
      }
    }

  }


  let resetForm = () => {
    let data =
    {
      projectName: '',
      scLead: '',
      buid: '',
      country: '',
      category: '',
      subCategory: '',
      brand: '',
      launchYear: '',
      launchWeek: '',
      projectStatus: '',
      bigBet: '',
      uploadPic: '',
      risk: '',
      comment: '',
      format: '',
      projectExpectation: '',
      issaved: false,
      brandsInfo: {
        selectedBrand: 0,
        list: [
          {
            toSaveMileStone: false,
            "brand_key": "",
            "country_key": "",
            "Launch_Quarter": "",
            "Launch_Year": ""
          }
        ]
      }
    }
    setFormData(data)
    // @ts-ignore
    reset(data)
    setImagePreview("");
  }



  const fetchscLeads = async () => {
    try {
      const data = await getSclead();
      let output = data.map((item: any) => ({
        key: item.sclead_key,
        value: item.sclead_name
      }));
      setScLeads(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchYears = async () => {
    try {
      const data = await getLaunchYears();
      let output = data.map((item: any) => ({
        key: item.launchYears_key,
        value: item.launchYears_value
      }));
      // @ts-ignore
      setLaunchYears(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchFormat = async () => {
    try {
      const data = await getFormat();
      // @ts-ignore
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setFormats(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchQuarters = async () => {
    try {
      const data = await getLaunchQuarter();
      //console.log("datt qqtr", data)
      let output = data.map((item: any) => ({
        key: item.Launch_Quarter,
        value: item.Launch_QuarterName
      }));
      // @ts-ignore
      setLaunchWeeks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchBigbets = async () => {
    try {
      const data = await getBigbets();
      let output = data.map((item: any) => ({
        key: item.bigbet_key,
        value: item.bigbetvalue
      }));
      // @ts-ignore
      setBigBets(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchRisks = async () => {
    try {
      const data = await getRisks();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name
      }));
      // @ts-ignore
      setRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchProjectStatus = async () => {
    try {
      const data = await getProjectStatus();
      let output = data.map((item: any) => ({
        key: item.projectStatus_key,
        value: item.projectStatusvalue
      }));
      // @ts-ignore
      setProjectStatus(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchGlobalFilters = async (filter: any, value: any) => {
    try {
      let payload = {

      }
      if (filter == 'all') {
        payload = {
          "buid": filter == 'all' ? [] : filter == 'buid' ? [parseInt(value)] : filter == 'country' || filter == 'category' || filter == 'subCategory' ? [parseInt(formData.buid)] : [],
          "countryKey": filter == 'all' ? [] : filter == 'country' ? [parseInt(value)] : filter == 'category' || filter == 'subCategory' ? [parseInt(formData.country)] : [],
          "categoryKey": filter == 'all' ? [] : filter == 'category' ? [parseInt(value)] : filter == 'subCategory' ? [parseInt(formData.category)] : [],
          "subCategoryKey": filter == 'all' ? [] : filter == 'subCategory' ? [parseInt(value)] : [],
          "brandKey": []
        }
      }
      else if (filter == 'buid') {
        payload = {
          "buid": filter == 'all' ? [] : filter == 'buid' ? [parseInt(value)] : filter == 'country' || filter == 'category' || filter == 'subCategory' ? [parseInt(formData.buid)] : []
        }
      }
      else {
        payload = {
          "categoryKey": filter == 'all' ? [] : filter == 'category' ? [parseInt(value)] : filter == 'subCategory' ? [parseInt(formData.category)] : [],
          "subCategoryKey": filter == 'all' ? [] : filter == 'subCategory' ? [parseInt(value)] : [],
        }
      }

      // @ts-ignore
      const data = await getHCGlobalFilters(payload);
      // @ts-ignore
      if (data.data) {
        if (filter === 'all') {
          // @ts-ignore
          setBuids(data?.data.bu)
          // @ts-ignore
          setCountries(data?.data.country)
          // @ts-ignore
          setCategories(data.data.category)
          // @ts-ignore
          setSubCategories(data?.data.subCategory)
          // @ts-ignore
          setBrands(data?.data?.brand)
        }
        else if (filter === 'buid') {
          // @ts-ignore
          setCountries(data?.data.country)

        }
        else if (filter === 'category') {
          // @ts-ignore
          setSubCategories(data?.data.subCategory)
          // @ts-ignore
          setBrands(data?.data?.brands)
        }
        else if (filter === 'subCategory') {
          // @ts-ignore
          setBrands(data?.data?.brand)
        }
        else if (filter === 'brand') {

          setTimeout(function () {
            // @ts-ignore
            setBrands(data?.data?.brand)
          }, 500);

        }
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };
  const handleFileChange = async (file: any) => {
    if (!file) return;
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes 
    if (file.size > MAX_FILE_SIZE) {
      errorToast('Image size must be less than 5 MB');
      return;
    }
    try {
      setImagePreview(URL.createObjectURL(file));
      const formdata = new FormData();
      formdata.append("image", file, file.name);
      let data = await uploadImage(formdata);

      setFormData({
        ...formData,
        uploadPic: data.filename
      });
      setLoading(false)
    } catch (error) {
      console.error('Error uploading image:', error);
      errorToast('Failed to upload image. Please try again.');
    }
  };

  const handleRemoveImg = (file: any) => {
    setImagePreview('')
  };

  let handleFormChange = (name: any, value: any) => {
    clearErrors(name)
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16).toUpperCase();
    });
  }


  const handleClose = () => {
    setOpen(false);
  };

  const toggleCalendar = (calendarId: any) => {
    //   setIsCalendarOpen(!isCalendarOpen);
    setOpenCalendar((prev) => (prev === calendarId ? null : calendarId)); // Toggle calendar open/close

  };

  const handleDateSelect = (date: string, fieldName: string) => {
    {/* @ts-ignore */ }
    const formattedDate = date.format('DD-MM-YYYY');
    {/* @ts-ignore */ }
    setValue(fieldName, formattedDate);
    {/* @ts-ignore */ }
    trigger(fieldName);
    setOpenCalendar(null);
  };

  let updateAnswer = (obj: any, array: any, ans: any) => {
    const { Innoflex_Phase_Key, Innoflex_Phase_Options_Key } = obj;
    const phase = array.find(
      (item: any) => item.InnoflexPhase_key === Innoflex_Phase_Key
    );

    if (phase) {
      const question = phase.questions.find(
        (q: any) => q.Innoflex_Phase_Options_Key === Innoflex_Phase_Options_Key
      );

      if (question) {
        question.ans = ans;
      } else {
        console.log("Question not found with the specified Innoflex_Phase_Options_Key");
      }
    } else {
      console.log("Phase not found with the specified Innoflex_Phase_Key");
    }
    return array;
  }

  let handleAnswerSelect = (val: any, ans: boolean) => {
    let obj = {
      // @ts-ignore
      "Innoflex_Phase_Key": innoflexStages[activeInnoflexStage].InnoflexPhase_key,
      "Project_Key": 1,
      "Innoflex_Phase_Options_Key": val.Innoflex_Phase_Options_Key,
      "Innoflex_Phase_Options_Status": ans
    }
    const updatedArray = updateAnswer(obj, innoflexQuestions, ans);
    let temp = [...updatedArray]
    {/* @ts-ignore */ }
    setInnoflexQuestions(temp)
  }

  let handleInnoflexSave = async () => {
    setInnoflexSuccessModal(true)

    let temp = []
    {/* @ts-ignore */ }
    innoflexQuestions[activeInnoflexStage].questions.map((val, i) => {
      if (val.ans === null) return
      let obj = {
        "Project_Key": 1,
        //@ts-ignore
        "Innoflex_Phase_Key": innoflexQuestions[activeInnoflexStage].InnoflexPhase_key,
        "Innoflex_Phase_Options_Key": val.Innoflex_Phase_Options_Key,
        "Innoflex_Phase_Options_Status": val.ans
      }
      temp.push(obj)
    })

  }

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: appData.url });
  }
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: appData.url });
    //handleFormSubmit(false, appData.url)()
    saveDraft('')
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };
  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }
  }

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      await saveDraft('');
      hasAutoSaved.current = true;
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let handleAddBrands = () => {
    if (formData.brandsInfo.list.length == 6) return
    let obj = {
      "brand_key": "",
      "country_key": "",
      "Launch_Quarter": "",
      "Launch_Year": "",
      toSaveMileStone: false
    }
    let temp = [...formData.brandsInfo.list]
    temp.push(obj)
    setFormData({
      ...formData,
      brandsInfo: ({
        ...formData.brandsInfo,
        list: temp
      })
    })
  }

  let handleRemoveBrand = (index: any) => {
    let temp = [...formData.brandsInfo.list]
    let filteredData = temp.filter((val, i) => i !== index)
    setFormData({
      ...formData,
      brandsInfo: ({
        ...formData.brandsInfo,
        list: filteredData
      })
    })
  }

  console.log("form ->", formData)
  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "10px", borderRadius: "20px", pt: 3 }}>
          <CardContent>
            <div className="button-top-form">
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "end", pb: 4 }}
              >
                {/* <Button disabled={isDisabled} onClick={handleFormSubmit(true, '')} variant="contained"
                  sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Submit</Button> */}

                <Button disabled={isDisabled} onClick={() => saveDraft('')} variant="contained"
                  sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Draft & continue </Button>
                <Button disabled={isDisabled} onClick={() => handleCancel()} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important' }} className={classes.cancelButton}>Cancel</Button>

              </Stack>

            </div>
            <form noValidate>
              <Grid container spacing={3}>
                <Grid size={12}>
                  <h5 className="txt-mandatory-title">*Fields are mandatory</h5>
                </Grid>
                <Grid size={3}>
                  <label className="txt-label-input">Project Name<span className="required-txt">*</span></label>
                  <TextInput isDisabled={isDisabled} name="projectName" label="" control={control} errors={errors} onChange={(e) => handleFormChange(e.target.name, e.target.value)} />
                </Grid>

                <Grid size={3}>
                  <label className="txt-label-input">SC Lead<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="scLead"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("scLead", val);
                            clearErrors("scLead");
                          }}
                          options={scLeads}
                          isError={!!errors.scLead}
                        />
                      )}
                    />
                  </div>
                  {errors.scLead && <p className="error-message">{errors.scLead.message}</p>}
                </Grid>
                <Grid size={3}>
                  <label className="txt-label-input">Business Unit<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">

                    <Controller
                      name="buid"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("buid", val);
                            clearErrors("buid");
                            fetchGlobalFilters('buid', val)
                          }}
                          options={buids}
                          isError={errors.buid ? true : false}
                        />
                      )}
                    />
                  </div>
                  {errors.buid && <p className="error-message">{errors.buid.message}</p>}
                </Grid>
                <Grid size={3}>
                  <label className="txt-label-input">Big Bet</label>
                  <div className="project_drpdnw">
                    <Controller
                      name="bigBet"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("bigBet", val);
                            clearErrors("bigBet");
                          }}
                          options={bigBets}
                          isError={errors.bigBet ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.bigBet && <p className="error-message">{errors.bigBet.message}</p>}
                </Grid>
                <Grid size={3}>
                  <label className="txt-label-input">Category<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="category"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("category", val);
                            clearErrors("category");
                            fetchGlobalFilters('category', val)
                          }}
                          options={categories}
                          isError={errors.category ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.category && <p className="error-message">{errors.category.message}</p>}
                </Grid>
                <Grid size={3}>
                  <label className="txt-label-input">Master Brand<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="subCategory"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("subCategory", val);
                            clearErrors("subCategory");
                            fetchGlobalFilters('subCategory', val)
                          }}
                          options={subCategories}
                          isError={errors.subCategory ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.subCategory && <p className="error-message">{errors.subCategory.message}</p>}
                </Grid>

                {/* <Grid size={4}>
                  <label className="txt-label-input">Brand<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="brand"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("brand", val);
                            clearErrors("brand");
                            fetchGlobalFilters('brand', val)

                          }}
                          options={brands}
                          isError={errors.brand ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.brand && <p className="error-message">{errors.brand.message}</p>}
                </Grid> */}

                {/* <Grid size={4}>
                  <label className="txt-label-input">Launch Year<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="launchYear"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("launchYear", val);
                            clearErrors("launchYear");
                          }}
                          options={launchYears}
                          isError={errors.launchYear ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.launchYear && <p className="error-message">{errors.launchYear.message}</p>}
                </Grid> */}

                {/* <Grid size={4}>
                  <label className="txt-label-input">Launch Quarter<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="launchWeek"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("launchWeek", val);
                            clearErrors("launchWeek");
                          }}
                          options={launchWeeks}
                          isError={errors.launchWeek ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.launchWeek && <p className="error-message">{errors.launchWeek.message}</p>}
                </Grid> */}
                <Grid size={3}>
                  <label className="txt-label-input">Project Status<span className="required-txt">*</span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="projectStatus"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("projectStatus", val);
                            clearErrors("projectStatus");
                          }}
                          options={projectStatus}
                          isError={errors.projectStatus ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.projectStatus && <p className="error-message">{errors.projectStatus.message}</p>}
                </Grid>


              </Grid>
              <Grid container spacing={3} mt={2}>
                <Grid size={12}>
                  <div className="box-waplist-card">
                    <div className="table-responsive">
                      <table className="table tablechart-wts">
                        <thead className="thead-listwp">
                          <tr>
                            <th></th>
                            <th className="brands-info-heading">Country</th>
                            <th className="brands-info-heading">Brand <span className="required-txt-wt">*</span></th>
                            <th className="brands-info-heading">Launch Year <span className="required-txt-wt">*</span></th>
                            <th className="brands-info-heading">Launch Quarter <span className="required-txt-wt">*</span></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.brandsInfo.list.map((val, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <label className="radio-button">
                                    <input
                                      type="radio"
                                      className="radio-button__input"
                                      name="choice1"
                                      checked={val.toSaveMileStone}
                                      onClick={() => {
                                        const updatedList = formData.brandsInfo.list.map((item, idx) => ({
                                          ...item,
                                          toSaveMileStone: idx === index
                                        }));

                                        setFormData({
                                          ...formData,
                                          brandsInfo: {
                                            ...formData.brandsInfo,
                                            list: updatedList
                                          }
                                        });
                                      }}
                                    />

                                    <span className="radio-button__control"></span>
                                  </label>
                                </td>
                                <td>
                                  <div className="select-dropwap">
                                    <div className="project_drpdnw">
                                      <Controller
                                        name={`brandsInfo.list.${index}.country` as any}
                                        control={control}
                                        render={({ field }) => {
                                          const selectedCountries = formData.brandsInfo.list
                                            .filter((_, idx) => idx !== index)
                                            .map(item => item.country_key);
                                          // const filteredCountries = countries.filter(
                                          //   // @ts-ignore 
                                          //   country => !selectedCountries.includes(String(country.key))
                                          // );
                                          return (
                                            <SelectDropdown
                                              isDisabled={isDisabled}
                                              filterKey=""
                                              label=""
                                              value={field.value}
                                              onChange={(val) => {
                                                field.onChange(val);
                                                const updatedList = [...formData.brandsInfo.list];
                                                updatedList[index] = {
                                                  ...updatedList[index],
                                                  country_key: val
                                                };
                                                setFormData({
                                                  ...formData,
                                                  brandsInfo: {
                                                    ...formData.brandsInfo,
                                                    list: updatedList
                                                  }
                                                });
                                                clearErrors(`brandsInfo.list.${index}.country` as any);
                                                //    fetchGlobalFilters('country', val);
                                              }}
                                              options={countries}
                                              isError={errors.brandsInfo?.list?.[index]?.country_key ? true : false}
                                            />
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="select-dropwap">
                                    <div className="project_drpdnw">
                                      <Controller
                                        name={`brandsInfo.list.${index}.brand` as any}
                                        control={control}
                                        render={({ field }) => {
                                          const currentCountry = formData.brandsInfo.list[index].country_key;
                                          const selectedBrandsForCountry = formData.brandsInfo.list
                                            .filter((_, idx) => idx !== index && _.country_key === currentCountry)
                                            .map(item => item.brand_key);
                                          const filteredBrands = brands ? brands.filter(
                                            // @ts-ignore 
                                            brand => !selectedBrandsForCountry.includes(String(brand.key))
                                          )
                                            :
                                            brands

                                          return (
                                            <SelectDropdown
                                              filterKey=""
                                              label=""
                                              value={field.value}
                                              isDisabled={isDisabled}
                                              onChange={(val) => {
                                                field.onChange(val);
                                                const updatedList = [...formData.brandsInfo.list];
                                                updatedList[index] = {
                                                  ...updatedList[index],
                                                  brand_key: val
                                                };
                                                setFormData({
                                                  ...formData,
                                                  brandsInfo: {
                                                    ...formData.brandsInfo,
                                                    list: updatedList
                                                  }
                                                });
                                                clearErrors(`brandsInfo.list.${index}.brand` as any);
                                                //  fetchGlobalFilters('brand', val);
                                              }}
                                              options={filteredBrands}
                                              isError={!!errors.brandsInfo?.list?.[index]?.brand_key}
                                            />
                                          );
                                        }}
                                      />


                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="select-dropwap">
                                    <div className="project_drpdnw">
                                      <Controller
                                        name={`brandsInfo.list.${index}.launchYear` as any}
                                        control={control}
                                        render={({ field }) => (
                                          <SelectDropdown
                                            filterKey=""
                                            isDisabled={isDisabled}
                                            label=""
                                            value={field.value}
                                            onChange={(val) => {
                                              field.onChange(val);
                                              const updatedList = [...formData.brandsInfo.list];
                                              updatedList[index] = {
                                                ...updatedList[index],
                                                Launch_Year: val
                                              };
                                              setFormData({
                                                ...formData,
                                                brandsInfo: {
                                                  ...formData.brandsInfo,
                                                  list: updatedList
                                                }
                                              });
                                              clearErrors(`brandsInfo.list.${index}.launchYear` as any);
                                            }}
                                            options={launchYears}
                                            isError={errors.brandsInfo?.list?.[index]?.Launch_Year ? true : false}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="select-dropwap">
                                    <div className="project_drpdnw">
                                      <Controller
                                        name={`brandsInfo.list.${index}.launchQuarter` as any}
                                        control={control}
                                        render={({ field }) => (
                                          <SelectDropdown
                                            filterKey=""
                                            label=""
                                            isDisabled={isDisabled}
                                            value={field.value}
                                            onChange={(val) => {
                                              field.onChange(val);
                                              const updatedList = [...formData.brandsInfo.list];
                                              updatedList[index] = {
                                                ...updatedList[index],
                                                Launch_Quarter: val
                                              };
                                              setFormData({
                                                ...formData,
                                                brandsInfo: {
                                                  ...formData.brandsInfo,
                                                  list: updatedList
                                                }
                                              });
                                              clearErrors(`brandsInfo.list.${index}.launchQuarter` as any);
                                            }}
                                            options={launchWeeks}
                                            isError={errors.brandsInfo?.list?.[index]?.Launch_Quarter ? true : false}
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="action-flx-icon">
                                    <Button
                                      variant="contained"
                                      sx={{
                                        borderRadius: "50%",
                                        minWidth: 32,
                                        width: 32,
                                        height: 31,
                                        paddingTop: 1,
                                        marginRight: '2px',
                                        backgroundColor: formData.brandsInfo.list.length >= 6 ? "#d9d9d9" : "#72ded9",
                                        color: "#000",
                                        fontWeight: "bold",
                                        fontSize: "22px",
                                        lineHeight: 1,
                                        "&:hover": {
                                          backgroundColor: formData.brandsInfo.list.length >= 6 ? "#d9d9d9" : "#72ded9",
                                        },
                                        // padding: 0,
                                      }}
                                      onClick={handleAddBrands}
                                    >
                                      +
                                    </Button>

                                    {
                                      formData.brandsInfo?.selectedBrand !== index ?

                                        <Button
                                          variant="contained"
                                          sx={{
                                            borderRadius: "50%",
                                            minWidth: 32,
                                            width: 32,
                                            height: 31,
                                            paddingTop: 0.5,
                                            lineheight: 40,
                                            backgroundColor: "#f2a5a9",   // light red
                                            color: "#000",                // black text
                                            fontWeight: "bold",
                                            fontSize: "24px",             // bigger dash
                                            lineHeight: 1,
                                            "&:hover": {
                                              backgroundColor: "#f2a5a9",
                                            },
                                            // padding: 0,
                                          }}
                                          onClick={() => handleRemoveBrand(index)}
                                        >
                                          -
                                        </Button>
                                        :
                                        null
                                    }
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Grid>
              </Grid>

              <Grid container spacing={3} mt={2}>
                <Grid size={4}>
                  <Grid container spacing={2}>
                    <Grid size={4}>
                      <label className="txt-label-input">Upload Pic<span className="required-txt"></span></label>
                      <div className="file-upload-button">
                        <FileUpload  isDisabled={isDisabled} onFileChange={handleFileChange}
                          name="uploadPic" label="Browse" control={control} errors={errors} />
                      </div>
                    </Grid>
                    {
                      imagePreview ?
                        <Grid size={8}>
                          <div className="upload-image-preview">
                            <img src={imagePreview} alt="product" />
                            <span onClick={handleRemoveImg} className="cross-img-btn">x</span>
                          </div>
                        </Grid>
                        :
                        null
                    }

                  </Grid>

                </Grid>
              </Grid>
              <Stack sx={{ height: "1px", backgroundColor: "#0000003b", my: 3 }}></Stack>
              <Grid container spacing={2} mt={2}>
                <Grid size={8}>
                  <label className="txt-label-input">Format<span className="required-txt">*</span></label>
                  <div className="project_drpdnwFormat">
                    <Controller
                      name="format"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("format", val);
                            clearErrors("format");
                          }}
                          options={formats}
                          isError={errors.format ? true : false}
                        />
                      )}
                    />
                  </div>
                  {errors.format && <p className="error-message">{errors.format.message}</p>}
                </Grid>
                <Grid size={4}>
                  <div className="form-format">
                    <label className="txt-label-input">Project Exceptions<span className="required-txt"></span></label>
                    <TextInput isDisabled={isDisabled} className="project-exception-input" isComment={{ enabled: true, maxLength: 1000 }} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="projectExpectation" label="" control={control} errors={errors} multiline />
                  </div>
                </Grid>
              </Grid>


              <Grid container spacing={2} mt={2}>
                <Grid size={8}>
                  <label className="txt-label-input">Comment<span className="required-txt"></span></label>
                  <TextInput isDisabled={isDisabled} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />
                </Grid>
                <Grid size={4}>
                  <label className="txt-label-input">Project Risk<span className="required-txt"></span></label>
                  <div className="project_drpdnw">
                    <Controller
                      name="risk"
                      control={control}
                      render={({ field }) => (
                        <SelectDropdown
                          isDisabled={isDisabled}
                          filterKey=""
                          label=""
                          value={field.value}
                          onChange={(val) => {
                            field.onChange(val);
                            handleFilterChange("risk", val);
                            clearErrors("risk");
                          }}
                          options={risks}
                          isError={errors.risk ? true : false}

                        />
                      )}
                    />
                  </div>
                  {errors.risk && <p className="error-message">{errors.risk.message}</p>}
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="overFlow-modal-visible"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <span className="modal-title-ht">Innoflex Phase</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ overflowY: "visible" }}>
          <div className="date-relative-card">
            <Grid container spacing={1}>
              {
                innoflexStages.map((cal, cli) => {
                  {/* @ts-ignore */ }
                  let name = cal.InnoflexPhasevalue
                  return (
                    <Grid sx={{ maxWidth: '150px', mb: 2, position: "relative" }}>
                      <Controller
                        name={name}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            disabled={isDisabled}
                            {...field}
                            fullWidth
                            label=""
                            id=""
                            sx={{ input: { backgroundColor: '#fff', borderRadius: "20px", height: "17px !important" } }}
                            onKeyDown={(e) => e.preventDefault()}
                            error={!!error}
                            helperText={error ? error.message : ""}
                          />
                        )}
                      />
                      <span className="icon-date dateIcon-samll" onClick={() => toggleCalendar(`${name}x`)}>
                        <i className="fas fa-calendar-alt"></i>
                      </span>
                      {/* @ts-ignore */}
                      {openCalendar === `${name}x` && (<DateCalendarValue onDateSelect={(date) => handleDateSelect(date, name)} />
                      )}
                    </Grid>
                  )
                })
              }

            </Grid>
            <Grid container spacing={1}>
              {
                innoflexStages.map((val, idx) => {
                  return (

                    <Grid sx={{ width: '150px', mb: 2 }}>
                      {/* active */}
                      {/* @ts-ignore */}
                      <span onClick={() => setActiveInnoflexStage(idx)} className={`innof-flex-button ${activeInnoflexStage === idx ? 'active' : ""}`}>{val.InnoflexPhasevalue}</span>
                    </Grid>

                  )
                })
              }

            </Grid>

            <Grid container spacing={2}>
              <Grid size={12}>
                <TableContainer sx={{ overFlow: 'auto', height: '410px' }}>
                  <Table aria-label="simple table" sx={{ border: 0, borderRadius: "0px", overflow: "auto" }}>
                    <TableHead>
                      <TableRow sx={{ th: { border: 0, backgroundColor: "#d9d9d9", py: 1 } }}>
                        <TableCell sx={{ width: "20px" }}>S.No</TableCell>
                        <TableCell>Milestones</TableCell>
                        <TableCell sx={{ width: "150px", '&:last-child': { borderLeft: "2px solid #d0d0d0" } }}>Yes/No</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        innoflexQuestions.length > 0 ?
                          // @ts-ignore
                          innoflexQuestions[activeInnoflexStage].questions.map((val, i) => {
                            return (
                              <TableRow sx={{ td: { border: 0 } }}
                              >

                                <TableCell sx={{ fontSize: "13px", py: 1 }}>{i + 1}</TableCell>
                                {/* @ts-ignore */}
                                <TableCell sx={{ fontSize: "13px", py: 1 }}>{val.Milestone}</TableCell>
                                <TableCell sx={{ fontSize: "13px", py: 1, '&:last-child': { borderLeft: "2px solid #d0d0d0" } }}>
                                  <div className="action-br">
                                    <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, true)} className={`wt-ys-card ${val.ans === true ? 'active_ans' : ''}`}>Yes</span>
                                    <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, false)} className={`wt-ys-card ${val.ans === false ? 'active_ans' : ''}`}>No</span>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          })
                          :
                          null
                      }

                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus sx={{ backgroundColor: "#d9d9d9", borderRadius: "30px", color: "#535151", width: "120px", mr: 2 }} onClick={handleClose}>Cancel</Button>
          <Button onClick={handleInnoflexSave} sx={{ backgroundColor: "#2a3fbf", borderRadius: "30px", color: "#fff", width: "120px" }}>Save</Button>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={scOpnen}
        className="overFlow-modal-visible"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <span className="modal-title-ht">SC Phase</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setScOpen(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ overflowY: "visible" }}>
          <div className="date-relative-card">
            <Grid container spacing={1}>
              {
                innoflexStages.map((cal, cli) => {
                  {/* @ts-ignore */ }
                  let name = cal.InnoflexPhasevalue
                  return (
                    <Grid sx={{ maxWidth: '150px', mb: 2, position: "relative" }}>
                      <Controller
                        name={name}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            {...field}
                            fullWidth
                            label=""
                            id=""
                            sx={{ input: { backgroundColor: '#fff', borderRadius: "20px", height: "17px !important" } }}
                            onKeyDown={(e) => e.preventDefault()}
                            error={!!error}
                            helperText={error ? error.message : ""}
                          />
                        )}
                      />
                      <span className="icon-date dateIcon-samll" onClick={() => toggleCalendar(`${name}x`)}>
                        <i className="fas fa-calendar-alt"></i>
                      </span>
                      {/* @ts-ignore */}
                      {openCalendar === `${name}x` && (<DateCalendarValue onDateSelect={(date) => handleDateSelect(date, name)} />
                      )}
                    </Grid>
                  )
                })
              }

            </Grid>
            <Grid container spacing={1}>
              {
                innoflexStages.map((val, idx) => {
                  return (

                    <Grid sx={{ width: '150px', mb: 2 }}>
                      {/* active */}
                      {/* @ts-ignore */}

                      <span onClick={() => setActiveInnoflexStage(idx)} className={`innof-flex-button ${activeInnoflexStage === idx ? 'active' : ""}`}>{val.InnoflexPhasevalue}</span>
                    </Grid>

                  )
                })
              }

            </Grid>

            <Grid container spacing={2}>
              <Grid size={12}>
                <TableContainer sx={{ overFlow: 'auto', height: '410px' }}>
                  <Table aria-label="simple table" sx={{ border: 0, borderRadius: "0px", overflow: "auto" }}>
                    <TableHead>
                      <TableRow sx={{ th: { border: 0, backgroundColor: "#d9d9d9", py: 1 } }}>
                        <TableCell sx={{ width: "20px" }}>S.No</TableCell>
                        <TableCell>Milestones</TableCell>
                        <TableCell sx={{ width: "150px", '&:last-child': { borderLeft: "2px solid #d0d0d0" } }}>Yes/No</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        innoflexQuestions.length > 0 ?
                          // @ts-ignore 
                          innoflexQuestions[activeInnoflexStage].questions.map((val, i) => {
                            return (
                              <TableRow sx={{ td: { border: 0 } }}
                              >

                                <TableCell sx={{ fontSize: "13px", py: 1 }}>{i + 1}</TableCell>
                                {/* @ts-ignore */}
                                <TableCell sx={{ fontSize: "13px", py: 1 }}>{val.Milestone}</TableCell>
                                <TableCell sx={{ fontSize: "13px", py: 1, '&:last-child': { borderLeft: "2px solid #d0d0d0" } }}>
                                  <div className="action-br">
                                    <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, true)} className={`wt-ys-card ${val.ans === true ? 'active_ans' : ''}`}>Yes</span>
                                    <span style={{ cursor: 'pointer' }} onClick={() => handleAnswerSelect(val, false)} className={`wt-ys-card ${val.ans === false ? 'active_ans' : ''}`}>No</span>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          })
                          :
                          null
                      }

                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus sx={{ backgroundColor: "#d9d9d9", borderRadius: "30px", color: "#535151", width: "120px", mr: 2 }} onClick={handleClose}>Cancel</Button>
          <Button sx={{ backgroundColor: "#2a3fbf", borderRadius: "30px", color: "#fff", width: "120px" }}>Save</Button>
        </DialogActions>
      </BootstrapDialog>


      {/* @ts-ignore */}
      <InnoflexSaveModal open={innoflexSuccessModal} /> <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} />
      <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>

      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />

    </>

  );
};

export default ProjectForm;
